module.exports = __webpack_public_path__ + "img/warehouse.f2d440f8.png";